export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10499.31b18e5f.jpg";